import React from 'react';

interface DropdownButtonProps {
  text: string;
  icon: string;
  callback?: () => void;
}

const DropdownButton = ({ text, icon, callback }: DropdownButtonProps) => (
  <button
    className="dropdown-item tw-w-full"
    type="button"
    onClick={callback}
  >
    <i aria-hidden="true" className={`fa ${icon}`} />
    {text}
  </button>
);

export default DropdownButton;
